<template>
  <div class="chinaArea-container">
    <el-cascader
      ref="areaCascader"
      v-model="selectedOptions"
      :options="areaData"
      filterable
      clearable
      placeholder="请选择所属地区"
      @change="handleChange"
    />
  </div>
</template>

<script>
/**
  provinceAndCityData省市二级联动数据,汉字+code
  regionData省市区三级联动数据
  pcTextArr省市联动数据，纯汉字
  pcaTextArr省市区联动数据，纯汉字
  codeToText是个大对象，属性是区域码，属性值是汉字 用法例如：codeToText['110000']输出北京市
 */
import { pcaTextArr } from "element-china-area-data";
export default {
  props: {
    value: {
      type: [String, Array],
      default: () => []
    }
  },
  data() {
    return {
      areaData: pcaTextArr
    };
  },
  computed: {
    selectedOptions: {
      get() {
        const cityText = this.setArea(this.value);
        return cityText;
      },
      set(val) {
        return val;
      }
    }
  },

  methods: {
    emitInput(val) {
      this.$emit("input", val.join("/"));
    },
    setArea(areaValue = []) {
      if (typeof areaValue == "string") {
        areaValue = areaValue.split("/");
      }
      return areaValue;
    },
    handleChange(value) {
      this.emitInput(this.setArea(value));
    }
  }
};
</script>
<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
</style>
